// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__QbXXr","col":"styles_col__1-VXC","actions":"styles_actions__2NK5J","conflict":"styles_conflict__2Gim2"};